export const environment = {
  production: false,
  baseUrl: 'https://homologacao.vivest.com.br',
  apiPerfil: 'apis/api-perfil-investimento',
  chaveFornecedor: '7788f344-4e9b-4938-b11f-7f847c9d230c',
  secretPortal: '79f52b2cc565ef16f07d7f8f52df4ecdd7fa1923995f16333fc4b2055476a146',
  oacpPerfil: '2583487355d54beb8f62474ad0ad1276',
};
